// The status's indicator colour as a dot beside a Jungle Green label, never the colour alone.
const StatusDot = ({ className, label }: { className: string; label: string }) => (
  <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-palette-jungleGreen900">
    <span aria-hidden className={`h-2 w-2 shrink-0 rounded-full ${className}`} />
    {label}
  </span>
)

export default StatusDot
